import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const IMAGES = {
  logo: "/logo.png",
  hero: "https://static.prod-images.emergentagent.com/jobs/ca19d48b-8ce9-426a-9d16-eaf99c30e80a/images/2ff2c4c453d980db6f0a8e425ea35a4603a179d6734f555b64e71a9cc477ff71.png",
  pool: "https://images.pexels.com/photos/8688178/pexels-photo-8688178.jpeg",
  basketball: "https://images.unsplash.com/photo-1546519638-68e109498ffc?w=1600&q=80",
  volleyball: "https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=1600&q=80",
  games: "https://static.prod-images.emergentagent.com/jobs/ca19d48b-8ce9-426a-9d16-eaf99c30e80a/images/4be4ce6df1b27332abdb2117e8ec7df4e75e78412830371275c85941099a34aa.png",
  worship: "https://images.unsplash.com/photo-1522158637959-30385a09e0da?w=1600",
  speaker: "/pastor.png",
};

export const PLAN_LABELS = {
  daily: "Diario",
  weekly: "Semanal",
  biweekly: "Quincenal",
  monthly: "Mensual",
};

export const CHURCH_WHATSAPP = "16145080303";
export const SQUARE_PAYMENT_URL = "https://square.link/u/V3wccgXL";
